import { openDB } from "idb";

const DB_NAME = "cima-db";
const STORE_NAME = "service-orders-data";

const initDB = async () => {
  return openDB(DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    },
  });
};

export const localSaveServiceOrder = async (key, data) => {
  const db = await initDB();
  return db.put(STORE_NAME, data, key);
};

export const localGetServiceOrder = async (key) => {
  const db = await initDB();
  return db.get(STORE_NAME, key);
};

export const localGetAllServiceOrders = async () => {
  const db = await initDB();
  return db.getAll(STORE_NAME);
};

export const localDeleteServiceOrder = async (key) => {
  const db = await initDB();
  return db.delete(STORE_NAME, key);
};

export const localCountServiceOrder = async () => {
  const db = await initDB();
  return db.count(STORE_NAME);
};
